/**
 * Must load before any other app imports.
 * CRA/webpack injected Node polyfills globally; Vite does not.
 */
import { Buffer } from "buffer";

const globalScope = globalThis as typeof globalThis & {
  Buffer?: typeof Buffer;
  process?: { env: Record<string, string | undefined> };
};

if (typeof globalScope.Buffer === "undefined") {
  globalScope.Buffer = Buffer;
}

if (typeof globalScope.process === "undefined") {
  globalScope.process = { env: {} };
}
